import { Injectable } from '@angular/core';
import { BoardService } from '@secca/core/services/board.service';
import { SearchCase } from '@secca/shared/models/searchCase';
import { StakeholderTypeEnum } from '@secca/shared/models/enums';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AtlasCaseNumberLookupService {
  constructor(private boardService: BoardService) {}

  async resolveCaseIdByCaseNumber(caseNumber: string): Promise<string | null> {
    try {
      const normalizedCaseNumber = normalizeCaseNumberForLookup(caseNumber);
      if (!normalizedCaseNumber) {
        return null;
      }

      if (/^\d+$/.test(normalizedCaseNumber)) {
        return normalizedCaseNumber;
      }

      const results = await firstValueFrom(this.boardService.getSearchCase(createCaseNumberSearchRequest(normalizedCaseNumber)));
      const exactMatch = (results || []).find(result =>
        normalizeCaseNumberForLookup(result.caseNumber) === normalizedCaseNumber
      );
      const fallbackMatch = exactMatch || (results || [])[0];
      return fallbackMatch?.caseId ? String(fallbackMatch.caseId) : null;
    } catch {
      return null;
    }
  }
}

export function normalizeCaseNumberForLookup(caseNumber: string | null | undefined): string | null {
  const normalized = (caseNumber || '').trim().toUpperCase();
  return normalized && normalized !== '-' ? normalized : null;
}

export function createCaseNumberSearchRequest(caseNumber: string): SearchCase {
  return new SearchCase({
    customer: null,
    policyRefNo: '',
    customerRefNo: '',
    customerProduct: null,
    nationalIdCountryCode: null,
    nationalId: '',
    dateOfBirth: null,
    firstName: '',
    surname: '',
    email: '',
    phoneNumberCountryCode: null,
    phoneNumberPrefix: '',
    phoneNumber: '',
    homeCountryCode: null,
    companyName: '',
    stakeholderSearch: StakeholderTypeEnum.endUser,
    caseNumber,
    casePhoneNumber: '',
    caseCreationDateFrom: null,
    caseCreationDateTo: null,
    casePhoneNumberIncludedInSearch: true,
    incidentCause: '',
    incidentLocation: '',
    incidentDate: null
  });
}
